import React, {FC} from 'react';
import styled from 'styled-components';

import {EventHandler} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {center, transparent} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

export interface NavigationLineChevronProps {
  /** Event handler toggling between collapsed and expanded states. */
  onToggleExpandClick?: () => void;
  /** Is this navigation line expanded. */
  isExpanded?: boolean;
  isTransparent?: boolean;
}

/*
 * Style.
 */

interface ChevronButtonStyleProps {
  $isExpanded: boolean | undefined;
  $isTransparent: boolean | undefined;
}

export const StyledChevronButton = styled(ChromelessButton)<ChevronButtonStyleProps>`
  grid-area: chevron;
  ${center()};
  ${(p) => transparent(p.$isTransparent ?? false)}

  color: ${(p) => p.theme.leftBar.icon};
  &:hover {
    color: ${(p) => p.theme.leftBar.iconHover};
  }

  svg {
    transform: ${(p) => p.$isExpanded && 'rotate(90deg)'};
  }
`;

/*
 * Component.
 */

/** Expand/Collapse chevron for a P1 navigation line. */
export const NavigationLineChevron: FC<NavigationLineChevronProps> = (props) => {
  const onChevronClick: EventHandler = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (props.onToggleExpandClick) {
      props.onToggleExpandClick();
    }
  };

  if (!props.onToggleExpandClick) {
    return null;
  }

  return (
    <StyledChevronButton
      $isExpanded={props.isExpanded}
      $isTransparent={props.isTransparent}
      onClick={onChevronClick}
    >
      <Icon name="chevronRightSmall" />
    </StyledChevronButton>
  );
};
